import React from 'react'
import style from './articles.style'

const NastrojkaUon = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Подключение U-ON Travel CRM</h2>
      <p>
        Для подключения <strong>U-ON Travel</strong> необходимо добавить вебхук
        ROMI center для передачи данных о продажах.
      </p>
      <strong>Шаг 1.</strong>
      <ol className={classes.articleList}>
        <li>
          Войдите под своим аккаунтом в <strong>U-ON Travel</strong>
        </li>
        <li>
          Выберите меню <strong>Интеграции -> API/WebHooks</strong>{' '}
        </li>
      </ol>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/uon6.png" alt="true" />
      </figure>
      <strong>Шаг 2. Необходимо создать новый вебхук для сделки</strong>
      <ol className={classes.articleList}>
        <li>
          Нажмите на кнопку <strong>добавить новый WebHook</strong>
        </li>
        <li>
          В поле “Тип” выберите: <strong>Изменение статуса в заявке</strong>
        </li>
        <li>
          В поле “URL” напишите: <strong>https://romi.center/api/uon</strong>
        </li>
        <li>
          В поле “Метод” выберите: <strong>POST</strong>
        </li>
        <li>
          В поле “Примечание” напишите:{' '}
          <strong>Отправка сделки в сервис romi.center</strong>
        </li>
        <li>
          Нажмите <strong>Сохранить</strong>
        </li>
      </ol>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/uon4.png" alt="true" />
      </figure>
      <strong>
        Шаг 3. Настройка коннектора U-ON Travel в личном кабинете ROMI center:
      </strong>
      <p>Введите данные подключения в коннекторе:</p>
      <ol className={classes.articleList}>
        <li>
          Введите адрес вашей CRM в <strong>U-ON Travel</strong>
        </li>
        <li>
          Введите <strong>API-ключ</strong>
        </li>
        <li>
          <strong>Включите передачу</strong> данных с пустым ClientID
        </li>
        <li>
          Нажмите <strong>Далее</strong>
        </li>
      </ol>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/uon3.png" alt="true" />
      </figure>
      <p>Пример заполненной формы</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/uon5.png" alt="true" />
      </figure>
      <p>API-ключ можно взять в интерфейсе U-ON:</p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/uon2.png" alt="true" />
      </figure>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/uon1.png" alt="true" />
      </figure>
      <p>
        Обязательно включите галки <strong>“Разрешить GET запросы”</strong> и{' '}
        <strong>“Разрешить POST запросы”</strong>
      </p>
      <strong>Шаг 4. Выберите настройки коннектора.</strong>
      <ol className={classes.articleList}>
        <li>
          Выберите куда в Google Analytics отправлять данные о продажах: в{' '}
          <strong>Электронную торговлю</strong> или создать цель{' '}
          <strong>“Успешные продажи”</strong> и отправлять в цель. Мы
          рекомендуем отправлять данные о продажах в{' '}
          <strong>Электронную торговлю</strong>, так как это позволит учитывать
          возвраты.
        </li>
        <li>
          Выберите статусы сделки, которые соответствуют{' '}
          <strong>успешно завершенной сделке.</strong> Можно выбрать несколько
          статусов, если вам необходимо например учитывать разные способы
          оплаты: “Оплата безналом” и “Оплата наличными”. Обратите внимание, что
          одна сделка не может проходить через два статуса оплаты. Пример:
          “Частичная оплата” и “Полная оплата”, в таком случае сделка
          задублируется в отчете продаж.
        </li>
        <li>
          Выберите статус <strong>“Возврата”</strong> в вашей CRM системе. Эта
          опция доступна, только в случае, если выбрана отправка в{' '}
          <strong>Электронную торговлю.</strong>
        </li>
        <li>
          Нажмите <strong>Подключить.</strong>
        </li>
      </ol>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/uon7.png" alt="true" />
      </figure>
      <strong>
        Шаг 5. Настройка передачи параметра Google Client id в U-ON Travel
      </strong>
      <p>
        Настройте передачу Google Client id из формы заявки на сайте в U-ON
        Travel в заявку в поле <strong>Примечание.</strong>
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/uon8.png" alt="true" />
      </figure>
      <p>
        Google Client id должен быть записан в поле <strong>Примечание</strong>{' '}
        в формате <strong>GA1.2.XXXXXXXXXX.XXXXXXXXXX</strong>. Обычно он
        выглядит вот так: “GA1.2.2029541258.1577186246"
      </p>
      <p>
        Настройка передачи Google Сlient id с сайта в CRM подробно описана в{' '}
        <a href="/help/poluchenie-clientid" className={classes.link}>
          статье.
        </a>
      </p>
      <p>
        Если у вас возникли сложности с передачей параметра Google Client id в
        CRM, обратитесь техническую поддержку ROMI center.
      </p>
    </article>
  )
}

export default style(NastrojkaUon)
